import type {BioIconProps} from './common-types'

export function ArrowIcon({fill, ...attributes}: BioIconProps) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M9.83333 3.83325L14.5 8.49992M14.5 8.49992L9.83333 13.1666M14.5 8.49992H2.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
